(function(){
  var D=(window.SOOS_DATA||{});
  var P=D.P||[],SETS=D.SETS||[],BUNDLE=D.BUNDLE||[],CD_HOURS=D.CD_HOURS||24,FREE_T=D.FREE_T||125;
  console.log(D.CD_HOURS);
  console.log('test');
  var CART='/cart/', PROD='/products/';
  var IMG='';
  // Verified against Shopify Admin (16 Jun 2026): live prices, real compare-at, real handles & variant IDs, sales rank.
  
  // Bestselling ready-made sets (by sales, last 12 months)
  
  // Big bundle (used in cart drawer rendering)
  

  function euro(n){return '€'+n.toFixed(2).replace('.',',');}
  function pct(p,was){return was?('−'+Math.round((1-p/was)*100)+'%'):'';}
  function badge(it){return it.free?'1+1 FREE':(it.was?pct(it.p,it.was):'');}

  /* ---- generated product reviews (stable per product) ---- */
  var R_NAMES=['Sophie','Lena','Klara','Eva','Noor','Anne','Lotte','Sanne','Julia','Emma','Femke','Lisa','Iris','Maud','Tess','Roos','Fleur','Sara','Nina','Hannah','Marit','Daan','Bram','Tom','Pieter','Sven','Bas','Joost','Wouter','Mila','Saar','Isa','Lieke','Britt','Yara','Floor','Jasmijn','Bo','Sterre','Guusje'];
  var R_CITY=['Amsterdam','Rotterdam','Utrecht','Den Haag','Eindhoven','Groningen','Haarlem','Leiden','Delft','Nijmegen','Maastricht','Breda','Tilburg','Antwerp','Ghent','Bruges','Leuven','Zwolle','Arnhem','Amersfoort','Alkmaar','Deventer'];
  var R_DATE=['Jan 2026','Feb 2026','Mar 2026','Apr 2026','May 2026','Jun 2026','Sep 2025','Oct 2025','Nov 2025','Dec 2025','Aug 2025','Jul 2025'];
  var R_TXT=[
   'Absolutely beautiful in person - even better than the photos. The quality feels properly premium.',
   'Survives the dishwasher every single day without a single scratch. Couldn\'t be happier.',
   'Looks so much more expensive than it was. Guests always ask where it\'s from.',
   'Bought one, came straight back for more. It just works with everything on the table.',
   'Lightweight but sturdy, and the finish is gorgeous. Exactly what I was hoping for.',
   'The 1+1 free deal sealed it for me - incredible value for this quality.',
   'Arrived quickly and beautifully packaged. Felt like a real treat to unwrap.',
   'We use these literally every day now. Unbreakable and still look brand new.',
   'Perfect weight and balance. The steel has a lovely soft shine, not too mirror-like.',
   'Honestly the nicest tableware I own. Modern, timeless and built to last.',
   'Gifted a set to my mum and now I need another for myself. Everyone loves them.',
   'Five stars. Sleek, durable and so easy to clean. No regrets at all.',
   'Great for kids too - no more broken plates and they still look elegant.',
   'The matte steel matches my whole kitchen. Such a clean, calm look.',
   'Better than expected quality for the price. Will definitely order more pieces.',
   'Takes me back to dinners at my grandmother\'s, but make it modern. Love it.',
   'Camping, picnics, fancy dinners - these do it all and never let me down.',
   'Ordered during the sale and so glad I did. The finish is flawless.',
   'Stackable, scratch-resistant and genuinely beautiful. A new staple in our home.',
   'Customer service was lovely and the product is even better. Highly recommend.',
   'Four stars - only because I wish they made an even bigger size!',
   'Solid, elegant and practical. Hard to find tableware this good-looking that lasts.',
   'Bought it on a whim and it\'s now my favourite thing in the kitchen.',
   'Feels heirloom quality. I can see us using these for years and years.',
   'Delivery was quick and everything arrived flawless. Not a single dent.',
   'The finish is so calming. Fits any table, casual or fancy.',
   'My partner was sceptical, now he wants the whole collection.',
   'No more chipped ceramics in this house. These just keep going.',
   'Such a thoughtful design. Comfortable to hold and lovely to look at.',
   'I host a lot and these always get compliments. Worth every cent.',
   'Quality you can feel the moment you pick it up. Really impressed.',
   'Subtle, elegant and practical. Exactly the upgrade our table needed.',
   'Second order already. Started with one piece and got hooked.',
   'Looks high end but is so easy to live with day to day.',
   'Cleans up in seconds and never stains. A dream for busy mornings.',
   'Even nicer than I imagined. The weight feels reassuringly solid.',
   'Great gift idea. I bought one for myself and two for friends.',
   'These have survived toddlers, picnics and the dishwasher. Bulletproof.',
   'A small luxury that makes everyday meals feel a bit special.',
   'Beautifully minimal. Goes with my plates, glasses, everything.',
   'Five months in and still looks like the day it arrived.',
   'Sturdy, stylish and genuinely good value. Can\'t fault it.',
   'The packaging alone felt premium. The product even more so.',
   'Finally tableware that looks designed, not mass produced.',
   'I keep recommending these to everyone who visits. Just lovely.',
   'Four stars, only because I want them to release more colours!',
   'Perfect size and finish. Does exactly what I hoped and more.',
   'Honestly obsessed. This is the third time I\'ve reordered.',
   'Feels like a proper investment piece at a very fair price.',
   'Modern, durable and timeless. Hard to ask for more.'
  ];
  function prng(seed){return function(){seed=(seed*9301+49297)%233280;return seed/233280;};}
  function seedOf(it){var s=0,k=String(it.v);for(var i=0;i<k.length;i++)s=(s+k.charCodeAt(i)*(i+7))%99991;return s+3;}
  function revCount(it){var r=prng(seedOf(it));return 90+Math.floor(r()*620);}
  function genReviews(it){
    var r=prng(seedOf(it)+11),out=[],used={},n=19+Math.floor(r()*9);
    for(var i=0;i<n&&Object.keys(used).length<R_TXT.length;i++){
      var ti;do{ti=Math.floor(r()*R_TXT.length);}while(used[ti]);used[ti]=1;
      var st=5,t=R_TXT[ti];
      if(t.indexOf('Four stars')===0)st=4;else if(t.indexOf('Five stars')===0)st=5;else if(r()<0.12)st=4;
      out.push({name:R_NAMES[Math.floor(r()*R_NAMES.length)],city:R_CITY[Math.floor(r()*R_CITY.length)],date:R_DATE[Math.floor(r()*R_DATE.length)],txt:t,stars:st});
    }
    return out;
  }

  /* TOP 3 ROWS */
  var rows=document.getElementById('rows'),rh='';
  P.slice(0,3).forEach(function(it,i){
    rh+='<div class="row'+(i%2?' flip':'')+'">'
     +'<div class="r-img"><span class="r-rank">'+it.r+'</span>'+(badge(it)?'<span class="r-badge'+(it.free?' free':'')+'">'+badge(it)+'</span>':'')+'<img loading="lazy" alt="'+it.t+'" src="'+it.img+'"></div>'
     +'<div class="r-copy"><span class="sold">★★★★★ Bestseller</span><h3>'+it.t+'</h3><p>'+it.d+'</p>'
     +'<div class="r-meta"><span class="r-price"><b>'+euro(it.p)+'</b>'+(it.was?'<s>'+euro(it.was)+'</s>':'')+'</span>'+(it.free?'<span class="tag-free">1+1 FREE</span>':'')+'<button class="stars-btn" data-v="'+it.v+'">★★★★★ <small>('+revCount(it)+')</small></button></div>'
     +'<a class="btn btn-blue" href="'+CART+it.v+':1">Add to cart · '+euro(it.p)+'</a></div></div>';
  });
  rows.innerHTML=rh;

  /* GRID 4-10 */
  var grid=document.getElementById('grid'),gh='';
  P.slice(3).forEach(function(it){
    gh+='<div class="card"><div class="card-img"><span class="card-rank">'+it.r+'</span>'
     +'<a href="'+PROD+it.u+'"><img loading="lazy" alt="'+it.t+'" src="'+it.img+'"></a>'
     +(badge(it)?'<span class="card-badge'+(it.free?' free':'')+'">'+badge(it)+'</span>':'')+'</div>'
     +'<div class="card-b"><h3>'+it.t+'</h3>'
     +'<div class="pr"><b>'+euro(it.p)+'</b>'+(it.was?'<s>'+euro(it.was)+'</s>':'')+'</div>'
     +'<div class="sold2"><button class="stars-btn" data-v="'+it.v+'">★★★★★ <small>('+revCount(it)+')</small></button></div>'
     +'<a class="btn btn-blue" href="'+CART+it.v+':1">Add to cart</a></div></div>';
  });
  grid.innerHTML=gh;

  /* SETS GRID */
  var sg=document.getElementById('set-grid'),sh='';
  SETS.forEach(function(it){
    sh+='<div class="card"><div class="card-img">'
     +'<a href="'+PROD+it.u+'"><img loading="lazy" alt="'+it.t+'" src="'+it.img+'"></a>'
     +(badge(it)?'<span class="card-badge'+(it.free?' free':'')+'">'+badge(it)+'</span>':'')+'</div>'
     +'<div class="card-b"><h3>'+it.t+'</h3>'
     +'<div class="pr"><b>'+euro(it.p)+'</b>'+(it.was?'<s>'+euro(it.was)+'</s>':'')+'</div>'
     +'<div class="sold2"><button class="stars-btn" data-v="'+it.v+'">★★★★★ <small>('+revCount(it)+')</small></button></div>'
     +'<a class="btn btn-blue" href="'+CART+it.v+':1">Add to cart</a></div></div>';
  });
  sg.innerHTML=sh;

  /* BUNDLE BUILDER */
  var SEL={}, FREE=FREE_T, bdGrid=document.getElementById('bd-grid');
  var bh='';P.forEach(function(it){
    bh+='<div class="bd-tile" data-v="'+it.v+'"><div class="bd-thumb-w"><img class="bd-thumb" loading="lazy" alt="'+it.t+'" src="'+it.img+'">'+(badge(it)?'<span class="bd-badge'+(it.free?' free':'')+'">'+badge(it)+'</span>':'')+'</div>'
     +'<div class="bd-info"><h4>'+it.t+'</h4><div class="bd-p"><b>'+euro(it.p)+'</b>'+(it.was?'<s>'+euro(it.was)+'</s>':'')+'</div>'
     +(it.free?'<div class="bd-free">1+1 free · you get 2</div>':'')
     +'<div class="bd-qty" data-v="'+it.v+'"><button class="bd-minus" aria-label="minus">−</button><span class="bd-n">0</span><button class="bd-plus" aria-label="plus">+</button></div>'
     +'</div></div>';
  });
  bdGrid.innerHTML=bh;

  /* shared catalog map for cart */
  var byV={};P.concat(SETS,BUNDLE).forEach(function(it){byV[it.v]=it;});
  function recv(it,units){return units*(it&&it.free?2:1);}

  /* reviews modal */
  var rvOv=document.getElementById('rev-ov'),rvEl=document.getElementById('rev'),rvBody=document.getElementById('rev-body'),rvTitle=document.getElementById('rev-title'),rvSum=document.getElementById('rev-sum');
  function openReviews(v){var it=byV[v];if(!it)return;var list=genReviews(it);
    var avg=list.reduce(function(a,b){return a+b.stars;},0)/list.length;avg=Math.max(4.7,Math.min(4.9,avg));
    rvTitle.textContent=it.t;
    rvSum.innerHTML='<div class="rev-avg">'+avg.toFixed(1).replace('.',',')+'</div><div><div class="rev-avg-stars">★★★★★</div><div class="rev-avg-sub">Based on '+revCount(it)+' verified reviews</div></div>';
    var h='';list.forEach(function(rv){h+='<div class="rev-item"><div class="rev-i-top"><span class="rev-i-stars">'+(rv.stars===5?'★★★★★':'★★★★☆')+'</span><span class="rev-i-ver">✓ Verified buyer</span></div><p>'+rv.txt+'</p><div class="rev-i-who">'+rv.name+', '+rv.city+' · '+rv.date+'</div></div>';});
    rvBody.innerHTML=h;rvBody.scrollTop=0;
    rvEl.classList.add('open');rvOv.classList.add('show');
  }
  function closeReviews(){rvEl.classList.remove('open');rvOv.classList.remove('show');}

  function bdRender(){
    var pieces=0,total=0,value=0;
    Object.keys(SEL).forEach(function(v){var it=byV[v],u=SEL[v];pieces+=recv(it,u);total+=u*it.p;value+=u*(it.free?2*it.p:(it.was||it.p));});
    document.getElementById('bd-count').textContent=pieces+(pieces===1?' piece · ':' pieces · ')+euro(total);
    document.getElementById('bd-save').textContent=(pieces&&value>total)?('save '+euro(value-total)):'';
    document.getElementById('bd-ship').textContent=total>=FREE?'✓ Free shipping unlocked':(pieces?'Add '+euro(FREE-total)+' for free shipping':'Add pieces to build your set');
    document.getElementById('bd-fill').style.width=Math.min(100,total/FREE*100)+'%';
    var btn=document.getElementById('bd-add');btn.disabled=!pieces;btn.textContent=pieces?('Add '+pieces+' to cart · '+euro(total)):'Select pieces to add';
    bdGrid.querySelectorAll('.bd-tile').forEach(function(t){var v=t.getAttribute('data-v');t.classList.toggle('sel',!!SEL[v]);t.querySelector('.bd-n').textContent=recv(byV[v],SEL[v]||0);});
  }
  function bdSet(v,d){SEL[v]=Math.max(0,(SEL[v]||0)+d);if(!SEL[v])delete SEL[v];bdRender();}
  bdGrid.addEventListener('click',function(e){
    var qy=e.target.closest('.bd-qty');
    if(qy){var v=qy.getAttribute('data-v');
      if(e.target.classList.contains('bd-plus'))bdSet(v,1);
      else if(e.target.classList.contains('bd-minus'))bdSet(v,-1);
      return;}
    var t=e.target.closest('.bd-tile');if(t)bdSet(t.getAttribute('data-v'),1);
  });
  document.getElementById('bd-all').addEventListener('click',function(){P.forEach(function(it){SEL[it.v]=1;});bdRender();});
  document.getElementById('bd-add').addEventListener('click',function(){
    var items=Object.keys(SEL).map(function(v){return {id:v,units:SEL[v]};});if(!items.length)return;shopifyAdd(items);
  });
  bdRender();

  /* SHOPIFY AJAX CART  ----------------------------------------- */
  var toastEl=document.getElementById('toast'),toastT;
  function showToast(msg){clearTimeout(toastT);toastEl.innerHTML=msg;toastEl.classList.add('show');toastT=setTimeout(function(){toastEl.classList.remove('show');},2800);}
  function openCartDrawer(){var d=document.querySelector('cart-drawer');if(d&&typeof d.open==='function'){d.open();}else{var b=document.getElementById('cart-icon-bubble');if(b)b.click();}}
  function shopifyAdd(items){
    var payload={items:items.map(function(i){return {id:parseInt(i.id,10),quantity:i.units||1};}),sections:['cart-drawer','cart-icon-bubble'],sections_url:window.location.pathname};
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(payload)})
     .then(function(r){return r.json().then(function(d){return {ok:r.ok,d:d};});})
     .then(function(res){
       if(!res.ok){window.location.href='/cart';return;}
       var t=byV[items[0].id];
       showToast('<span>Added <b>'+(t?t.t:'item')+'</b>'+(t&&t.free?' · 1+1 free':'')+'</span><a class="t-co" href="#" id="toast-co">View cart</a>');
       var co=document.getElementById('toast-co');if(co)co.addEventListener('click',function(e){e.preventDefault();openCartDrawer();});
       var drawer=document.querySelector('cart-drawer');
       if(drawer&&typeof drawer.renderContents==='function'&&res.d&&res.d.sections){drawer.renderContents(res.d);}
       else{openCartDrawer();}
     })
     .catch(function(){window.location.href='/cart';});
  }
  function parseItems(href){var p=(href.split('/cart/')[1]||'').split('?')[0];if(!p)return null;return p.split(',').map(function(x){var a=x.split(':');return {id:a[0],units:parseInt(a[1]||'1',10)};});}
  /* delegated clicks: add-to-cart links + reviews modal */
  document.addEventListener('click',function(e){
    var sb=e.target.closest('.stars-btn');if(sb){e.preventDefault();openReviews(sb.getAttribute('data-v'));return;}
    if(e.target.closest('#rev-x')||e.target.id==='rev-ov'){closeReviews();return;}
    var a=e.target.closest('a[href*="/cart/"]');
    if(a){var items=parseItems(a.getAttribute('href'));if(items){e.preventDefault();shopifyAdd(items);return;}}
  });

  /* COUNTDOWN */
  // var KEY='soos_hl_deadline';
  // var dl=parseInt(localStorage.getItem(KEY)||'0',10);
  // if(!dl||dl<Date.now())dl=Date.now()+CD_HOURS*3600*1000;
  // try{localStorage.setItem(KEY,dl);}catch(e){}
  // function two(n){return (n<10?'0':'')+n;}
  // function tick(){
  //   var d=Math.max(0,dl-Date.now());
  //   var h=Math.floor(d/3600000),m=Math.floor(d%3600000/60000),s=Math.floor(d%60000/1000);
  //   document.getElementById('cd-h').textContent=two(h);
  //   document.getElementById('cd-m').textContent=two(m);
  //   document.getElementById('cd-s').textContent=two(s);
  //   document.getElementById('s-cd').textContent=two(h)+':'+two(m)+':'+two(s);
  //   if(d<=0){dl=Date.now()+CD_HOURS*3600*1000;try{localStorage.setItem(KEY,dl);}catch(e){}}
  // }
  // tick();setInterval(tick,1000);

  var CD_H = Number(D.CD_HOURS || 7);
var CD_M = Number(D.CD_MINUTES || 0);

/* Safety */
if (CD_M < 0) CD_M = 0;
if (CD_M > 59) CD_M = 59;

var CD_DURATION =
  (CD_H * 60 * 60 * 1000) +
  (CD_M * 60 * 1000);

var KEY = 'soos_hl_deadline';
var CONFIG_KEY = 'soos_hl_duration';

var CURRENT_CONFIG = CD_H + ':' + CD_M;
var dl = 0;

try {
  var savedConfig = localStorage.getItem(CONFIG_KEY);
  dl = parseInt(localStorage.getItem(KEY) || '0', 10);

  /* Reset if duration changed or timer expired */
  if (
    !dl ||
    dl <= Date.now() ||
    savedConfig !== CURRENT_CONFIG
  ) {
    dl = Date.now() + CD_DURATION;

    localStorage.setItem(KEY, dl);
    localStorage.setItem(CONFIG_KEY, CURRENT_CONFIG);
  }

} catch (e) {
  dl = Date.now() + CD_DURATION;
}

function two(n) {
  return (n < 10 ? '0' : '') + n;
}

function tick() {
  var d = Math.max(0, dl - Date.now());

  var h = Math.floor(d / 3600000);
  var m = Math.floor((d % 3600000) / 60000);
  var s = Math.floor((d % 60000) / 1000);

  var hourEl = document.getElementById('cd-h');
  var minuteEl = document.getElementById('cd-m');
  var secondEl = document.getElementById('cd-s');
  var stickyEl = document.getElementById('s-cd');

  if (hourEl) hourEl.textContent = two(h);
  if (minuteEl) minuteEl.textContent = two(m);
  if (secondEl) secondEl.textContent = two(s);

  if (stickyEl) {
    stickyEl.textContent =
      two(h) + ':' + two(m) + ':' + two(s);
  }

  /* Restart countdown when finished */
  if (d <= 0) {
    dl = Date.now() + CD_DURATION;

    try {
      localStorage.setItem(KEY, dl);
    } catch (e) {}
  }
}

tick();
setInterval(tick, 1000);

  /* STICKY MOBILE ADD-TO-CART (#1 product) */
  var hot=P[0];
  document.getElementById('sticky-thumb').src=hot.img;
  document.getElementById('sticky-thumb').alt=hot.t;
  document.getElementById('sticky-name').textContent=hot.t;
  document.getElementById('sticky-price').innerHTML='<b>'+euro(hot.p)+'</b>'+(hot.free?' <span style="color:var(--blue)">· 1+1 FREE</span>':'');
  var sAdd=document.getElementById('sticky-add');
  sAdd.href=CART+hot.v+':1';sAdd.textContent='Add '+euro(hot.p);
  var sticky=document.getElementById('sticky');
  var hideZones=[document.getElementById('shl-bundle'),document.querySelector('footer')],inZone=false;
  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(es){es.forEach(function(en){en.target._vis=en.isIntersecting;});inZone=hideZones.some(function(z){return z&&z._vis;});if(inZone)sticky.classList.remove('show');},{threshold:0.04});
    hideZones.forEach(function(z){if(z)io.observe(z);});
  }
  window.addEventListener('scroll',function(){sticky.classList.toggle('show',!inZone&&window.scrollY>window.innerHeight*0.75);},{passive:true});

})();
